import { TYPES } from "./payout_daily.type";

const INITIAL_STATE = {
  records: [],
  loading: false,
};

const payoutDailyReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.GET_PAYOUT_DAILY_REQUEST:
      return { ...state, loading: true };
    case TYPES.GET_PAYOUT_DAILY_SUCCESS:
      return { ...state, loading: false, records: payload };
    default:
      return state;
  }
};

export default payoutDailyReducer;
